<template>
  <div
    class="tab"
    :class="{'tab-active': isActive}"
    @click="handleClick">
    <slot name="icon">
      <i :class="icon"></i>
    </slot>
    <slot>
      <div v-html="label"></div>
    </slot>
  </div>
</template>
<script type="text/ecmascript-6">
const COMPONENT_NAME = 'Tab'
export default {
  name: COMPONENT_NAME,
  props: {
    label: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.$parent.addTab(this)
  },
  destroyed () {
    this.$parent.removeTab(this)
  },
  computed: {
    isActive () {
      return this.$parent.value === this.label
    }
  },
  methods: {
    handleClick (item) {
      this.$parent.trigger(this.label)
    }
  }
}
</script>
<style lang="scss">
  .tab {
    flex: 1;
    padding: 7px 0;
    color: #666;
    font-size: 20px;
    text-align: center;
    &.tab-active {
      color: #409bff!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tab/tab.vue